import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Clickable } from '@carvana/merch-components';
import classNames from 'classnames';
import { useContext } from 'react';
import getDataQaToDisplay from '@/SearchResults/Pagination/getDataQaToDisplay';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import ArrowBackIcon from '~/icons/ArrowBack';
import ArrowForwardIcon from '~/icons/ArrowForward';
import getNumbersToDisplay from './getNumbersToDisplay';
import { PaginationButton, PaginationNumber } from './Pagination.styles';
import { usePagination } from '../hooks';

const Pagination = () => {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { pagination: currentPagination, updatePagination } = usePagination();
  const { currentPage = 1, totalMatchedPages = 1 } = currentPagination;
  const paginationNumbers = getNumbersToDisplay(currentPage, totalMatchedPages);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalMatchedPages;

  return (
    <ul
      className="bg-transparent flex justify-around mx-auto pb-24 pt-[50px] px-0 w-full m:gap-8 m:justify-center m:w-fit"
      data-qa="pagination-wrapper"
      id="pagination"
    >
      {!isFirstPage && (
        <Clickable
          element={PaginationButton}
          data-analytics-id={null}
          data-qa="previous-page"
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'previousPage',
              page: currentPage - 1
            });
            updatePagination('subtract');
            setSearchSource(SearchSource.Pagination);
          }}
        >
          <ArrowBackIcon className="fill-blue-4 w-[6px]" />
        </Clickable>
      )}
      {paginationNumbers.map(number => {
        const shouldNotInteract =
          number < 0 ||
          (number === totalMatchedPages && currentPage < totalMatchedPages - 3);

        return (
          <Clickable
            element={PaginationNumber}
            data-analytics-id={null}
            data-qa={getDataQaToDisplay(currentPage, totalMatchedPages, number)}
            className={classNames({
              'border border-blue-3 border-solid t-header-xs':
                number === currentPage,
              't-body-s': number !== currentPage,
              'hover:bg-grey-3': !shouldNotInteract
            })}
            onClick={() => {
              if (shouldNotInteract) return;
              trackEvent('Pagination - clicked', {
                controlType: 'pageNumber',
                page: number
              });
              updatePagination('custom', number);
              setSearchSource(SearchSource.Pagination);
            }}
            key={number}
          >
            {number > 0 ? number : '...'}
          </Clickable>
        );
      })}
      {!isLastPage && (
        <Clickable
          element={PaginationButton}
          data-analytics-id={null}
          data-qa="next-page"
          onClick={() => {
            trackEvent('Pagination - clicked', {
              controlType: 'nextPage',
              page: currentPage + 1
            });
            updatePagination('add');
            setSearchSource(SearchSource.Pagination);
          }}
        >
          <ArrowForwardIcon className="fill-blue-4 w-[6px]" />
        </Clickable>
      )}
    </ul>
  );
};

export default Pagination;
